<div class="overlay" *ngIf="isLoading | async">
  <div class="spinner">
    <div class="spinner-part spinner-part1"></div>
    <div class="spinner-part spinner-part2"></div>
    <img src="/assets/images/motorbike.png" alt="Suzuki Bike" class="spinner-center">
  </div>
</div>

<div class="container-fluid pl-0 h-100">
  <div class="container-inner">
    <div *ngIf="!isCreate && !isEdit">
      <div class="header-container">
        <h2>Customer Requirement</h2>
          <div class="search-container">
          <input
            type="text"
            [formControl]="searchInput"
            placeholder="Search..."
            (input)="applyFilter()"
            class="form-control"
          />
          <span class="clear-icon" *ngIf="searchInput.value" (click)="clearSearch()">&times;</span>
        </div>
        <div class="button-container">
          <button mat-raised-button class="add-button" (click)="isCreate = true"> Add Customer Requirement</button>
        </div>
      </div>
      <div class="leads-table mb-3">
        <table mat-table [dataSource]="dataSource" matSort class="mat-table">
          <ng-container matColumnDef="SNo">
            <th mat-header-cell *matHeaderCellDef> S.No </th>
            <td mat-cell *matCellDef="let element; let i = index">{{i + 1}}</td>
          </ng-container>
          <ng-container matColumnDef="requirement">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Requirement</th>
            <td mat-cell *matCellDef="let element">{{element.requirement}}</td>
          </ng-container>
          <ng-container matColumnDef="interest_level">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Interest Level</th>
            <td mat-cell *matCellDef="let element">{{element?.interest_level?.interest_level}}</td>
          </ng-container>
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
            <td mat-cell *matCellDef="let element"
              [ngClass]="element.status == 1 ? 'status_active' : 'status_inactive'">
              {{element.status ? 'Active' : 'In-Active'}}</td>
          </ng-container>
          <ng-container matColumnDef="createdAt">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Created
              At</th>
            <td mat-cell *matCellDef="let element">{{element.createdAt |
              date:'dd/MM/yyyy'}}</td>
          </ng-container>
          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef style="text-align: center;">Action</th>
            <td mat-cell *matCellDef="let element" style="text-align: center;">
              <img [src]="bucketurl + '/images/pen.png'" class="edit-pen" title="Edit" (click)="edit(element)">
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" style="text-align: center; padding: 20px 0;" colspan="8">No data found!</td>
          </tr>
        </table>
      </div>
    </div>

    <div *ngIf="isCreate || isEdit">
      <div class="header-container">
        <h2>{{ isEdit ? 'Edit' : 'Add' }} Customer Requirement</h2>
        <div class="button-container">
          <button mat-raised-button class="add-button" (click)="back()">Back to
            List</button>
        </div>
      </div>
      <form [formGroup]="customerReq" (ngSubmit)="onSubmit()">
        <div class="row">


          <div class="col-12 col-sm-6 col-md-4 mt-2">
            <div class="themeinput">
              <label>Customer Requirement</label><span style="color: red; font-size: 15px;">&nbsp;*</span>
              <input type="text" class="form-control" formControlName="requirement"
                [ngClass]="{ 'is-invalid': submitted && f['requirement'].errors }">
              <div *ngIf="submitted && f['requirement'].errors" class="invalid-feedback">
                <div *ngIf="f['requirement'].errors['required']">Customer Requirement
                  is required</div>
              </div>
            </div>
          </div>

          <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-2">
            <div class="themeinput">
              <label>Interest Level</label><span style="color: red; font-size :15px">&nbsp;*</span>
              <select name="" class="form-select" formControlName="interest_level_id"
                [ngClass]="{ 'is-invalid': submitted && f['interest_level_id'].errors }">
                <option value="" disabled selected>--Select Interest Level--</option>
                <option [value]="data.id" *ngFor="let data of interestLevelList">{{data.interest_level}}</option>
              </select>
              <div *ngIf="submitted && f['interest_level_id'].errors" class="invalid-feedback">
                <div *ngIf="f['interest_level_id'].errors['required']">Interest Level is required</div>
              </div>
            </div>
          </div>

          <div class="col-12 col-sm-6 col-md-4 mt-2">
            <div class="themeinput">
              <label>Status</label><span style="color: red; font-size: 15px;">&nbsp;*</span>
              <select class="form-select" formControlName="status"
                [ngClass]="{ 'is-invalid': submitted && f['status'].errors }">
                <option value disabled>--Select Status--</option>
                <option value="1">Active</option>
                <option value="0">Inactive</option>
              </select>
              <div *ngIf="submitted &&  f['status'].errors" class="invalid-feedback">
                <div *ngIf=" f['status'].errors['required']">Status
                  is required</div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12 mt-4">
            <div class="text-right-right">
              <button type="button" mat-raised-button class="clear-button mr-3" (click)="clearForm()">Clear</button>
              <button type="submit" mat-raised-button class="create-button">{{
                isEdit ? 'Update' : 'Create' }}</button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>